import { Box, Button, CircularProgress, Stack, Tab, Tabs, Typography } from "@mui/material";
import Iconify from "../iconify/Iconify";
import InboxTable from "../inbox-table/InboxTable";
import PurchasesTable from "../purchases-table/PurchasesTable";
import CoinTransactionsTable from "../transactions-table/CoinTransactionsTable";

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
			{value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
		</div>
	);
}

export default function ProfileTabsSection({
	value,
	handleChangeTabs,
	transactions,
	purchases,
	messages,
	setOpenAddCoinsDialog,
	setOpenAllAccessPassDialog,
}: any) {
	return (
		<Box sx={{ width: "100%" }}>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs value={value} onChange={handleChangeTabs} aria-label="basic tabs example">
					<Tab label="Coins" {...a11yProps(0)} />
					{/* <Tab label='IAP' {...a11yProps(1)} /> */}
					{/* <Tab label='Refer a Friend' {...a11yProps(2)} /> */}
					{/* <Tab label='XP Rewards' {...a11yProps(3)} /> */}
					{/* <Tab label='Inbox' {...a11yProps(5)} /> */}
					{/* <Tab label='Tickets' {...a11yProps(7)} /> */}
				</Tabs>
			</Box>
			<TabPanel value={value} index={0}>
				<Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
					<Typography variant="h4" gutterBottom></Typography>
					<Button variant="contained" startIcon={<Iconify icon="eva:plus-outline" />} onClick={() => setOpenAddCoinsDialog(true)}>
						Add Coins
					</Button>
				</Stack>
				{transactions === null ? (
					<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
						<CircularProgress />
					</Box>
				) : (
					<CoinTransactionsTable transactions={transactions} />
				)}
			</TabPanel>
			<TabPanel value={value} index={1}>
				<Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
					<Typography variant="h4" gutterBottom></Typography>
					<Button variant="contained" startIcon={<Iconify icon="eva:plus-outline" />} onClick={() => setOpenAllAccessPassDialog(true)}>
						Add All Access Pass
					</Button>
				</Stack>
				<PurchasesTable purchases={purchases} />
			</TabPanel>
			{/* <TabPanel value={value} index={2}>
        <Stack direction='row' alignItems='center' justifyContent='end' mb={5}>
          <Button
            sx={{ ml: 2 }}
            variant='contained'
            startIcon={<Iconify icon='eva:plus-outline' />}
            onClick={() => setOpenReferralCodeDialog(true)}
          >
            Referral Code
          </Button>
        </Stack>
        {referralRewards !== null && <RewardsTable rewards={referralRewards} />}
      </TabPanel> */}
			{/* <TabPanel value={value} index={3}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          mb={5}
        >
          <Typography variant='h4' gutterBottom></Typography>
          <Button
            variant='contained'
            startIcon={<Iconify icon='eva:plus-outline' />}
            onClick={() => setOpenAddXpDialog(true)}
          >
            Add XP Rewards
          </Button>
        </Stack>
        {xpRewards !== null && <RewardsTable rewards={xpRewards} />}
      </TabPanel> */}
			<TabPanel value={value} index={5}>
				{messages !== null && <InboxTable rows={messages} />}
			</TabPanel>

			{/* <TabPanel value={value} index={7}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          mb={5}
        >
          <Typography variant='h4' gutterBottom></Typography>
          <Button
            variant='contained'
            startIcon={<Iconify icon='eva:plus-outline' />}
            onClick={() => setOpenAddTicketsDialog(true)}
          >
            Add Tickets
          </Button>
        </Stack>
        {ticketTransactions === null ? (
          <Box
            sx={{ display: 'flex', justifyContent: 'center' }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <TicketTransactionsTable transactions={ticketTransactions} />
        )}
      </TabPanel> */}
		</Box>
	);
}
